import { render, staticRenderFns } from "./Tablero.vue?vue&type=template&id=eca35b24&scoped=true&"
import script from "./Tablero.vue?vue&type=script&lang=js&"
export * from "./Tablero.vue?vue&type=script&lang=js&"
import style0 from "./Tablero.vue?vue&type=style&index=0&id=eca35b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca35b24",
  null
  
)

export default component.exports